function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icon/button/photo/zodiac-resized",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(11.666667, 8.333333) scale(-1, 1) translate(-11.666667, -8.333333) translate(3.333333, 0.000000)",
  stroke: "#1B2559"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy",
  x: 0.5,
  y: 0.5,
  width: 15.6666667,
  height: 15.6666667,
  rx: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy",
  fill: "#1B2559",
  cx: 12.5,
  cy: 4.16666667,
  r: 1
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-14",
  transform: "translate(0.775621, 9.722222)",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("polyline", {
  id: "Path-Copy-2",
  points: "0 4.58204149 5.10673153 0 11.6154223 6.31150113"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  points: "9.02830015 3.23981481 11.3158819 0.925925926 15.0663146 4.81868037"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group-9",
  transform: "translate(0.000000, 6.666667)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#1B2559",
  fill: "#EBEFFF",
  cx: 6.66666667,
  cy: 6.66666667,
  r: 6.16666667
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#1B2559",
  fillRule: "nonzero",
  points: "7.22222222 6.11111111 10 6.11111111 10 7.22222222 7.22222222 7.22222222 7.22222222 10 6.11111111 10 6.11111111 7.22222222 3.33333333 7.22222222 3.33333333 6.11111111 6.11111111 6.11111111 6.11111111 3.33333333 7.22222222 3.33333333"
}))));

function SvgZodiacResized(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZodiacResized);
export default __webpack_public_path__ + "static/media/zodiac-resized.70523fd1.svg";
export { ForwardRef as ReactComponent };